import React from "react";

import { BaseButtonProps } from "./types";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";

import "./styles.css";

const BaseButton = ({
  variant = "primary",
  size = "large",
  leadingIcon,
  trailingIcon,
  children,
  onClick,
  className,
  disabled = false,
  loading = false,
  isFullWidth = false,
}: BaseButtonProps) => {
  if (loading && !leadingIcon) {
    leadingIcon = <BaseSpinner size="extra-small" color="white" />;
  }

  return (
    <button
      className={`body-s-regular base-button base-button-${variant} base-button-${size} ${disabled || loading ? "base-button-disabled" : ""} ${isFullWidth ? "base-button-full-width" : ""} ${className || ""}`}
      onClick={disabled ? (e) => e.stopPropagation() : onClick}
    >
      {leadingIcon && <span>{leadingIcon}</span>}

      {children}

      {trailingIcon && <span>{trailingIcon}</span>}
    </button>
  );
};

export default BaseButton;
